/* Fase G+H: HBO Max fade + guard rails for overlays. */
theme.headerSticky = (function() {
  var headerEl = document.querySelector('.header_bottom');
  if (!headerEl) return function(){};

  var isPDP = headerEl.closest('[data-page-type="product"]') !== null;
  var FADE_START = isPDP ? 1 : 380;
  var FADE_END   = isPDP ? 50 : 430;

  var lastScrollY = 0;
  var ticking = false;

  function isAnyOverlayOpen() {
    if (document.getElementById('cfm17-root')) return true;
    if (document.body.classList.contains('cf-drawer-open')) return true;
    if (document.body.classList.contains('body-overflow-hidden')) return true;
    var offcanvas = document.querySelector('.offcanvas-header');
    if (offcanvas && offcanvas.classList.contains('open')) return true;
    return false;
  }

  function update() {
    if (isAnyOverlayOpen()) {
      headerEl.style.opacity = '1';
      headerEl.style.pointerEvents = 'auto';
      lastScrollY = window.scrollY;
      ticking = false;
      return;
    }

    var currentScrollY = window.scrollY;
    var goingDown = currentScrollY > lastScrollY;
    var opacity;

    if (goingDown) {
      if (currentScrollY <= FADE_START) {
        opacity = 1;
      } else if (currentScrollY >= FADE_END) {
        opacity = 0;
      } else {
        opacity = 1 - (currentScrollY - FADE_START) / (FADE_END - FADE_START);
      }
    } else {
      opacity = 1;
    }

    headerEl.style.opacity = opacity;
    if (opacity < 0.1) {
      headerEl.style.pointerEvents = 'none';
      headerEl.classList.add('cf-header-hidden');
    } else {
      headerEl.style.pointerEvents = 'auto';
      headerEl.classList.remove('cf-header-hidden');
    }

    // Notificar a la summary bar para el relevo
    if (opacity > 0.3) {
      document.dispatchEvent(new CustomEvent('covrfly:header-visible'));
    } else {
      document.dispatchEvent(new CustomEvent('covrfly:header-hidden'));
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  function ScrollSticky(){}
  return ScrollSticky;
})();
